import { gql } from "@apollo/client";

export const CREATE_DRIVER_PROFILE = gql`
  mutation createDriverUserProfile($id: String!, $driverUserInput: CreateDriverUserInput!){
    createDriverUserProfile(id: $id, driverUserInput: $driverUserInput){
      success
      message
    }
  }
`;